import { TODAY } from '@/lib/format'
import type { WeddingData, WeddingIdentity } from '@/mock/types'

export type WeddingIdentityErrors = Partial<Record<keyof WeddingIdentity, string>>

const tomorrow = new Date(`${TODAY}T12:00:00Z`)
tomorrow.setUTCDate(tomorrow.getUTCDate() + 1)
export const minimumWeddingDate = tomorrow.toISOString().slice(0, 10)

export function validateWeddingIdentity(identity: WeddingIdentity): WeddingIdentityErrors {
  const errors: WeddingIdentityErrors = {}
  if (!identity.brideName.trim()) errors.brideName = 'Doplňte jméno nevěsty.'
  else if (identity.brideName.trim().length > 100)
    errors.brideName = 'Jméno může mít nejvýše 100 znaků.'
  if (!identity.groomName.trim()) errors.groomName = 'Doplňte jméno ženicha.'
  else if (identity.groomName.trim().length > 100)
    errors.groomName = 'Jméno může mít nejvýše 100 znaků.'
  if (identity.date) {
    const date = new Date(`${identity.date}T12:00:00Z`)
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(identity.date) ||
      Number.isNaN(date.getTime()) ||
      date.toISOString().slice(0, 10) !== identity.date
    )
      errors.date = 'Zadejte platné datum svatby.'
    else if (identity.date < minimumWeddingDate) errors.date = 'Vyberte datum v budoucnosti.'
  }
  return errors
}

export function saveWeddingIdentity(data: WeddingData, identity: WeddingIdentity): WeddingData {
  return {
    ...data,
    identity: {
      brideName: identity.brideName.trim(),
      groomName: identity.groomName.trim(),
      date: identity.date,
    },
    tasks: data.tasks.map((task) =>
      task.automatic === 'wedding-date' ? { ...task, done: identity.date !== null } : task,
    ),
  }
}
